import { Controller } from "stimulus";
var onmount = require("onmount");

export default class extends Controller {
  static values = {
    checkinUrl: String,
    addonsUrl: String,
    date: String,
  };

  static targets = ["dateLabel", "checkinContent", "addonsContent", "todayButton", "searchInput", "clearButton", "sortLabel", "checkedInCount", "checkedInProgress", "checkedInCard"];

  localDateString(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  connect() {
    this.dateValue = this.localDateString(new Date());

    this.currentSort = localStorage.getItem("quick-checkin-sort") || "time";

    if (this.hasSortLabelTarget) {
      var labels = { time: "Time", pet_name: "Pet Name", service_name: "Service Name", client_last_name: "Client Last Name" };
      this.sortLabelTarget.textContent = labels[this.currentSort] || "Time";
    }

    this.boundUpdateCheckedInCount = this.updateCheckedInCount.bind(this);
    this.element.addEventListener("attendanceChanged", this.boundUpdateCheckedInCount);

    this.boundDismissPopovers = function (e) {
      if (!$(e.target).closest('[data-toggle="popover-clickable"], .popover').length) {
        $('[data-toggle="popover-clickable"]').data('pinned', false).popover('hide');
      }
    };
    $(document).on('click', this.boundDismissPopovers);

    this.loadContent();
  }

  disconnect() {
    this.element.removeEventListener("attendanceChanged", this.boundUpdateCheckedInCount);
    $(document).off('click', this.boundDismissPopovers);

    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
      this.flatpickrInstance = null;
    }
  }

  updateCheckedInCount() {
    if (!this.hasCheckedInCountTarget) return;

    var $content = $(this.checkinContentTarget);
    var checkedIn = $content.find(".js-attendance-icon.checked-in:not(.d-none)").length
      + $content.find(".js-attendance-icon.checked-out:not(.d-none)").length;
    var petsCount = parseInt(this.checkedInCardTarget.dataset.petsCount) || 0;
    var pct = petsCount > 0 ? Math.round((checkedIn / petsCount) * 100) : 0;

    this.checkedInCountTarget.textContent = checkedIn;
    this.checkedInProgressTarget.style.width = pct + "%";
  }

  previous() {
    this.dateValue = this.offsetDate(-1);
    this.loadContent();
  }

  next() {
    this.dateValue = this.offsetDate(1);
    this.loadContent();
  }

  gotoToday() {
    this.dateValue = this.localDateString(new Date());
    this.loadContent();
  }

  sort(event) {
    event.preventDefault();
    var sortValue = event.currentTarget.dataset.sortValue;
    var sortLabel = event.currentTarget.dataset.sortLabel;

    this.currentSort = sortValue;
    localStorage.setItem("quick-checkin-sort", sortValue);

    if (this.hasSortLabelTarget) {
      this.sortLabelTarget.textContent = sortLabel;
    }

    this.sortRows();
  }

  sortRows() {
    var sortValue = this.currentSort;
    var targets = [this.checkinContentTarget, this.addonsContentTarget];

    targets.forEach(function (target) {
      var $tbody = $(target).find("table tbody");
      if ($tbody.length === 0) return;

      var rows = $tbody.find("tr").get();
      rows.sort(function (a, b) {
        var aVal, bVal;
        if (sortValue === "pet_name") {
          aVal = (a.dataset.petName || "").toLowerCase();
          bVal = (b.dataset.petName || "").toLowerCase();
        } else if (sortValue === "service_name") {
          aVal = (a.dataset.serviceName || "").toLowerCase();
          bVal = (b.dataset.serviceName || "").toLowerCase();
        } else if (sortValue === "client_last_name") {
          aVal = (a.dataset.clientName || "").toLowerCase();
          bVal = (b.dataset.clientName || "").toLowerCase();
        } else {
          aVal = parseInt(a.dataset.startAt || "0", 10);
          bVal = parseInt(b.dataset.startAt || "0", 10);
          return aVal - bVal;
        }
        return aVal.localeCompare(bVal);
      });

      $.each(rows, function (_, row) {
        $tbody.append(row);
      });
    });
  }

  search() {
    var query = this.searchInputTarget.value.toLowerCase();
    var targets = [this.checkinContentTarget, this.addonsContentTarget];

    targets.forEach(function (target) {
      var rows = $(target).find("table tbody tr");
      rows.each(function () {
        var text = $(this).text().toLowerCase() + " " + (this.dataset.serviceName || "").toLowerCase();
        $(this).toggleClass("d-none", query !== "" && text.indexOf(query) === -1);
      });
    });

    if (query !== "") {
      $(this.clearButtonTarget).removeClass("d-none");
    } else {
      $(this.clearButtonTarget).addClass("d-none");
    }

    targets.forEach(function (target) {
      var $noResults = $(target).find(".js-search-no-results");
      var rows = $(target).find("table tbody tr");
      var visibleRows = rows.filter(":not(.d-none)").length;

      if (query !== "" && visibleRows === 0) {
        if ($noResults.length === 0) {
          $(target).append("<div class='text-center py-4 js-search-no-results'>No search results for '" + query + "'</div>");
        } else {
          $noResults.html("No search results for '" + query + "'").removeClass("d-none");
        }
      } else {
        $noResults.remove();
      }
    });
  }

  clearSearch(event) {
    event.preventDefault();
    this.searchInputTarget.value = "";
    $(this.clearButtonTarget).addClass("d-none");

    [this.checkinContentTarget, this.addonsContentTarget].forEach(function (target) {
      $(target).find("table tbody tr").removeClass("d-none");
      $(target).find(".js-search-no-results").remove();
    });
  }

  pickDate() {
    var controller = this;

    if (this.flatpickrInstance) {
      this.flatpickrInstance.open();
      return;
    }

    this.flatpickrInstance = flatpickr(this.dateLabelTarget, {
      disableMobile: "true",
      defaultDate: this.dateValue,
      onChange: function (selectedDates) {
        if (selectedDates.length === 1) {
          controller.dateValue = controller.localDateString(selectedDates[0]);
          controller.loadContent();
        }
      },
    });

    this.flatpickrInstance.open();
  }

  loadContent() {
    var controller = this;

    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = "";
    }

    if (this.hasClearButtonTarget) {
      $(this.clearButtonTarget).addClass("d-none");
    }

    var spinner = '<div class="text-center"><div class="spinner spinner-border spinner-border-sm text-primary mx-auto my-4"></div></div>';
    this.checkinContentTarget.innerHTML = spinner;
    this.addonsContentTarget.innerHTML = spinner;

    this.updateDateLabel();
    this.updateTodayVisibility();
    this.syncFlatpickr();

    this.fetchContent(this.checkinUrlValue, this.checkinContentTarget);
    this.fetchContent(this.addonsUrlValue, this.addonsContentTarget);
  }

  fetchContent(baseUrl, target) {
    var url = baseUrl;
    var controller = this;

    if (url.indexOf("?") !== -1) {
      url = url + "&date=" + this.dateValue;
    } else {
      url = url + "?date=" + this.dateValue;
    }

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (html) {
        target.innerHTML = html;
        var $target = $(target);
        $target.find('[data-toggle="tooltip"]').tooltip({ sanitize: false });
        $target.find('[data-toggle="popover"]').popover({ sanitize: false });
        $target.find('[data-toggle="popover-clickable"]').popover({ sanitize: false, trigger: 'manual' }).on('mouseenter', function () {
          var $this = $(this);
          if (!$this.data('pinned')) {
            $this.popover('show');
          }
        }).on('mouseleave', function () {
          var $this = $(this);
          if (!$this.data('pinned')) {
            $this.popover('hide');
          }
        }).on('click', function (e) {
          e.preventDefault();
          var $this = $(this);
          if ($this.data('pinned')) {
            $this.data('pinned', false).popover('hide');
          } else {
            $('[data-toggle="popover-clickable"]').data('pinned', false).popover('hide');
            $this.data('pinned', true).popover('show');
          }
        });
        onmount();
        if (controller.currentSort && controller.currentSort !== "time") {
          controller.sortRows();
        }
      },
      error: function () {
        window.notyf.error(
          "Something went wrong when loading your request. Please try again."
        );
      },
    });
  }

  updateDateLabel() {
    var date = new Date(this.dateValue + "T00:00:00");
    var options = { weekday: "short", month: "short", day: "numeric" };
    var formatted = date.toLocaleDateString("en-US", options);
    this.dateLabelTarget.childNodes[0].textContent = formatted;
  }

  updateTodayVisibility() {
    var today = this.localDateString(new Date());
    var isToday = this.dateValue === today;

    if (isToday) {
      $(this.todayButtonTarget).addClass("d-none");
      $(this.element).find(".js-for-today").removeClass("d-none");
    } else {
      $(this.todayButtonTarget).removeClass("d-none");
      $(this.element).find(".js-for-today").addClass("d-none");
    }
  }

  syncFlatpickr() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.setDate(this.dateValue, false);
    }
  }

  offsetDate(days) {
    var date = new Date(this.dateValue + "T00:00:00");
    date.setDate(date.getDate() + days);
    return this.localDateString(date);
  }
}
